(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nova-laden"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ---------- Oeffnungsstatus: Wochentage plus gesetzliche Feiertage in NRW (fest, ohne Pflege) ---------- */
    var T = 86400000;
    function berlin() {
      try {
        var t = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
        var o = {}; t.forEach(function (p) { o[p.type] = p.value; });
        return { heute: Date.UTC(parseInt(o.year, 10), parseInt(o.month, 10) - 1, parseInt(o.day, 10)), minuten: parseInt(o.hour, 10) % 24 * 60 + parseInt(o.minute, 10) };
      } catch (e) { return null; }
    }
    function minuten(s) { var m = /^(\d{1,2}):(\d{2})$/.exec(s || ''); return m ? parseInt(m[1], 10) * 60 + parseInt(m[2], 10) : null; }
    function ostern(j) {
      var a = j % 19, b = Math.floor(j / 100), c = j % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
      var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451), x = h + l - 7 * m + 114;
      return Date.UTC(j, Math.floor(x / 31) - 1, x % 31 + 1);
    }
    function feiertag(ms) {
      var d = new Date(ms), fest = { '1.1': 'Neujahr', '1.5': 'Tag der Arbeit', '3.10': 'Tag der Deutschen Einheit', '1.11': 'Allerheiligen', '25.12': '1. Weihnachtstag', '26.12': '2. Weihnachtstag' };
      var name = fest[d.getUTCDate() + '.' + (d.getUTCMonth() + 1)]; if (name) return name;
      var o = ostern(d.getUTCFullYear()), bew = {};
      bew[o - 2 * T] = 'Karfreitag'; bew[o + T] = 'Ostermontag'; bew[o + 39 * T] = 'Christi Himmelfahrt'; bew[o + 50 * T] = 'Pfingstmontag'; bew[o + 60 * T] = 'Fronleichnam';
      return bew[ms] || null;
    }
    function plan(ms, zeilen) {
      var z = zeilen[new Date(ms).getUTCDay() || 7] || { auf: null, zu: null, name: '' }, f = feiertag(ms);
      if (f) return { auf: null, zu: null, name: z.name, grund: f };
      return { auf: z.auf, zu: z.zu, aufText: z.aufText, zuText: z.zuText, name: z.name, grund: '' };
    }
    function setze(sek) {
      var status = sek.querySelector('[data-nl-status]'), jetzt = berlin();
      if (!status || !jetzt) return;
      var zeilen = {}, wtag = new Date(jetzt.heute).getUTCDay() || 7;
      sek.querySelectorAll('[data-nl-tag]').forEach(function (el) {
        var n = parseInt(el.dataset.nlTag, 10), th = el.querySelector ? el.querySelector('th') : null;
        zeilen[n] = { auf: minuten(el.dataset.nlAuf), zu: minuten(el.dataset.nlZu), aufText: el.dataset.nlAuf, zuText: el.dataset.nlZu, name: el.dataset.nlName || (th ? th.textContent.trim() : '') };
        el.classList.toggle('ist-heute', n === wtag);
      });
      var h = plan(jetzt.heute, zeilen), text = '', offen = false;
      if (h.auf !== null && jetzt.minuten >= h.auf && jetzt.minuten < h.zu) { text = 'Heute geöffnet bis ' + h.zuText + ' Uhr'; offen = true; }
      else if (h.auf !== null && jetzt.minuten < h.auf) { text = 'Wir öffnen heute um ' + h.aufText + ' Uhr'; }
      else {
        var anfang = h.grund ? 'Heute geschlossen (' + h.grund + ')' : 'Gerade geschlossen';
        for (var i = 1; i <= 10; i++) {
          var z = plan(jetzt.heute + i * T, zeilen);
          if (z.auf !== null) { text = anfang + ', wir öffnen ' + (i === 1 ? 'morgen' : 'am ' + z.name) + ' um ' + z.aufText + ' Uhr'; break; }
        }
      }
      status.classList.toggle('ist-offen', offen);
      if (text) { status.textContent = text; status.hidden = false; }
    }

    /* ---------- Anfahrtsrechner (arbeitet nur mit der eigenen Datendatei) ---------- */
    function glatt(s) { return (s || '').toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, ' ').trim(); }
    function mitte(liste) { var s = liste.slice().sort(function (x, y) { return x[2] - y[2]; }); return s[Math.floor((s.length - 1) / 2)]; }
    function rechner(box) {
      var form = box.querySelector('[data-nl-form]'), feld = box.querySelector('[data-nl-eingabe]'), aus = box.querySelector('[data-nl-ergebnis]'), liste = box.querySelector('[data-nl-vorschlaege]');
      if (!form || !feld || !aus) return;
      var daten = null, laedt = null, bahn = [], namen = [], aktiv = -1;
      try { bahn = JSON.parse(box.querySelector('[data-nl-bahnliste]').textContent) || []; } catch (e) {}
      function lade() {
        if (daten) return Promise.resolve(daten);
        if (!laedt) laedt = fetch(box.dataset.nlDaten).then(function (r) { return r.json(); }).then(function (j) {
          daten = j.orte || [];
          var gruppen = {};
          daten.forEach(function (o) { (gruppen[o[1]] = gruppen[o[1]] || []).push(o); });
          namen = Object.keys(gruppen).map(function (n) { var m = mitte(gruppen[n]); return { name: n, glatt: glatt(n), km: m[2], min: m[3], anzahl: gruppen[n].length }; });
          namen.sort(function (x, y) { return y.anzahl - x.anzahl || x.km - y.km; });
          return daten;
        });
        return laedt;
      }
      function links(herkunft) {
        var z = encodeURIComponent(box.dataset.nlZiel), h = encodeURIComponent(herkunft), basis = 'https://www.google.com/maps/dir/?api=1&origin=' + h + '&destination=' + z;
        box.querySelector('[data-nl-link-auto]').href = basis + '&travelmode=driving';
        box.querySelector('[data-nl-link-bahn]').href = basis + '&travelmode=transit';
      }
      function zeige(titel, km, min, ortsname, herkunft) {
        box.querySelector('[data-nl-titel]').textContent = titel;
        box.querySelector('[data-nl-km]').textContent = km === null ? 'siehe Route' : 'rund ' + km + ' km';
        box.querySelector('[data-nl-auto]').textContent = min === null ? 'siehe Route' : 'etwa ' + min + ' Minuten';
        var treffer = null, n = glatt(ortsname);
        bahn.forEach(function (b) { if (!treffer && n && glatt(b[0]) === n && b[1] && b[1] !== '–') treffer = b[1]; });
        box.querySelector('[data-nl-bahn]').textContent = treffer ? treffer.split(',')[0] : 'Bahn und Bus';
        box.querySelector('[data-nl-bahn-text]').textContent = treffer ? 'mit der Bahn bis Neuss Hbf' + (treffer.indexOf(',') > -1 ? ',' + treffer.split(',').slice(1).join(',') : '') + '; von dort rund neun Minuten zu Fuß' : 'bis Neuss Hbf oder Haltestelle Glockhammer; die Verbindung zeigt dir der Knopf unten';
        links(herkunft); aus.hidden = false; schliesse();
      }
      function schliesse() { if (liste) { liste.hidden = true; liste.innerHTML = ''; } aktiv = -1; feld.setAttribute('aria-expanded', 'false'); }
      function vorschlaege(text) {
        var roh = (text || '').trim(), treffer = [];
        if (roh.length < 2 || !daten) return treffer;
        var ziffern = roh.replace(/\D/g, '');
        if (/^\d/.test(roh) && ziffern.length >= 2) {
          var gesehen = {};
          daten.forEach(function (o) { if (treffer.length < 7 && o[0].indexOf(ziffern) === 0 && !gesehen[o[0]]) { gesehen[o[0]] = 1; treffer.push({ wert: o[0] + ' ' + o[1], km: o[2] }); } });
        } else {
          var g = glatt(roh.replace(/\d+/g, ' '));
          if (g.length < 2) return treffer;
          namen.forEach(function (n) { if (treffer.length < 7 && n.glatt.indexOf(g) === 0) treffer.push({ wert: n.name, km: n.km }); });
          if (treffer.length < 7) namen.forEach(function (n) { if (treffer.length < 7 && n.glatt.indexOf(g) > 0 && n.glatt.indexOf(' ' + g) > -1) treffer.push({ wert: n.name, km: n.km }); });
        }
        return treffer;
      }
      function male(text) {
        if (!liste) return;
        var t = vorschlaege(text); liste.innerHTML = ''; aktiv = -1;
        if (!t.length) { schliesse(); return; }
        t.forEach(function (v, i) {
          var li = document.createElement('li'); li.setAttribute('role', 'option'); li.id = liste.id + '-' + i;
          var s1 = document.createElement('span'); s1.textContent = v.wert; var s2 = document.createElement('small'); s2.textContent = 'rund ' + v.km + ' km';
          li.appendChild(s1); li.appendChild(s2);
          li.addEventListener('mousedown', function (e) { e.preventDefault(); feld.value = v.wert; suche(v.wert); });
          liste.appendChild(li);
        });
        liste.hidden = false; feld.setAttribute('aria-expanded', 'true');
      }
      function markiere(i) {
        var el = liste ? liste.children : []; if (!el.length) return;
        aktiv = (i + el.length) % el.length;
        Array.prototype.forEach.call(el, function (li, k) { li.classList.toggle('ist-aktiv', k === aktiv); });
        feld.setAttribute('aria-activedescendant', el[aktiv].id); el[aktiv].scrollIntoView({ block: 'nearest' });
      }
      function suche(text) {
        var roh = (text || '').trim(); if (!roh) { feld.focus(); return; }
        lade().then(function (orte) {
          var fuenf = roh.match(/\d{5}/), kurz = /^\d{3,4}$/.test(roh.replace(/\s+/g, '')) ? roh.replace(/\s+/g, '') : null, t, fund = null;
          if (fuenf) {
            t = orte.filter(function (o) { return o[0] === fuenf[0]; });
            if (t.length) { fund = mitte(t); zeige('Von ' + fund[0] + ' ' + fund[1] + ' zu uns nach Neuss', fund[2], fund[3], fund[1], fund[0] + ' ' + fund[1]); return; }
          } else if (kurz) {
            t = orte.filter(function (o) { return o[0].indexOf(kurz) === 0; });
            if (t.length) fund = mitte(t);
          }
          if (!fund) {
            var g = glatt(roh.replace(/\d+/g, ' '));
            if (g) {
              var genau = orte.filter(function (o) { return glatt(o[1]) === g; });
              var t2 = genau.length ? genau : orte.filter(function (o) { return glatt(o[1]).indexOf(g) === 0; });
              if (t2.length) fund = mitte(t2.filter(function (o) { return o[1] === t2[0][1]; }));
            }
          }
          if (fund) zeige('Von ' + fund[1] + ' zu uns nach Neuss', fund[2], fund[3], fund[1], fund[1]);
          else zeige('„' + roh + '“ liegt außerhalb unserer Liste (rund 70 km um Neuss). Die Route zeigt dir der Kartendienst.', null, null, '', roh);
        }).catch(function () { zeige('Die Entfernungsliste ließ sich gerade nicht laden. Die Route zeigt dir der Kartendienst.', null, null, '', roh); });
      }
      form.addEventListener('submit', function (e) { e.preventDefault(); suche(feld.value); });
      feld.addEventListener('focus', function () { lade().then(function () { male(feld.value); }).catch(function () {}); });
      feld.addEventListener('input', function () { lade().then(function () { male(feld.value); }).catch(function () {}); });
      feld.addEventListener('blur', function () { setTimeout(schliesse, 120); });
      feld.addEventListener('keydown', function (e) {
        if (!liste || liste.hidden) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); markiere(aktiv + 1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); markiere(aktiv - 1); }
        else if (e.key === 'Escape') { schliesse(); }
        else if (e.key === 'Enter' && aktiv > -1) { e.preventDefault(); var w = liste.children[aktiv].firstChild.textContent; feld.value = w; suche(w); }
      });
    }

    function init(root) {
      root.querySelectorAll('[data-nl]').forEach(function (sek) {
        setze(sek);
        if (!sek.dataset.nlTakt) { sek.dataset.nlTakt = '1'; setInterval(function () { setze(sek); }, 60000); }
        sek.querySelectorAll('[data-nl-rechner]').forEach(function (box) { if (!box.dataset.nlBereit) { box.dataset.nlBereit = '1'; rechner(box); } });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nova-ratgeber-reihe"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-nrr]').forEach(function (sek) {
        if (sek.dataset.nrrInit === '1') return;
        sek.dataset.nrrInit = '1';
        var reihe = sek.querySelector('[data-nrr-reihe]'), punkte = sek.querySelector('[data-nrr-punkte]');
        if (!reihe || !punkte) return;
        var karten = Array.prototype.slice.call(reihe.children);
        if (karten.length < 2) return;
        karten.forEach(function () { punkte.appendChild(document.createElement('li')); });
        var dots = Array.prototype.slice.call(punkte.children);
        function setze() {
          if (reihe.scrollWidth <= reihe.clientWidth + 4) { punkte.classList.remove('ist-bereit'); return; }
          punkte.classList.add('ist-bereit');
          var mitte = reihe.scrollLeft + reihe.clientWidth / 2, best = 0, abstand = Infinity;
          karten.forEach(function (k, i) {
            var d = Math.abs((k.offsetLeft + k.offsetWidth / 2) - mitte);
            if (d < abstand) { abstand = d; best = i; }
          });
          dots.forEach(function (d, i) { d.classList.toggle('ist-aktiv', i === best); });
        }
        reihe.addEventListener('scroll', setze, { passive: true });
        window.addEventListener('resize', setze);
        setze();
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nova-ratgeber-uebersicht"]) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-nru]').forEach(function (sek) {
        if (sek.dataset.nruInit === '1') return;
        sek.dataset.nruInit = '1';
        var liste = sek.querySelector('[data-nru-liste]');
        var leiste = sek.querySelector('[data-nru-chips]');
        if (!liste || !leiste) return;
        var chips = Array.prototype.slice.call(leiste.querySelectorAll('[data-nru-chip]'));
        var karten = Array.prototype.slice.call(liste.children);
        if (chips.length < 2 || !karten.length) return;
        function setze(key) {
          karten.forEach(function (k) {
            k.hidden = key !== 'alle' && k.getAttribute('data-nru-thema') !== key;
          });
          chips.forEach(function (c) {
            c.setAttribute('aria-pressed', c.getAttribute('data-nru-chip') === key ? 'true' : 'false');
          });
        }
        chips.forEach(function (c) {
          c.addEventListener('click', function () { setze(c.getAttribute('data-nru-chip')); });
        });
        var start = 'alle';
        try {
          var wunsch = new URLSearchParams(window.location.search).get('thema');
          if (wunsch) {
            chips.forEach(function (c) { if (c.getAttribute('data-nru-chip') === wunsch) start = wunsch; });
          }
        } catch (e) {}
        setze(start);
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pillar-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function darf() {
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed());
      } catch (e) { return false; }
    }
    function melde(name, daten) {
      if (!darf()) return;
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('spiritofgaia:' + name, daten || {});
        }
      } catch (e) {}
    }

    function init(root) {
      var wurzel = root.querySelector ? root.querySelector('.pillar') : null;
      if (!wurzel || wurzel.dataset.pillarInit === '1') return;
      wurzel.dataset.pillarInit = '1';
      var seite = wurzel.dataset.pillar || '';
      var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Inhaltsverzeichnis: am Handy zusammengeklappt, am Desktop offen (ohne JavaScript: offen)
      var tocDetails = wurzel.querySelector('[data-pillar-toc-details]');
      var klein = window.matchMedia ? window.matchMedia('(max-width: 989px)') : null;
      function tocAnpassen() { if (tocDetails && klein && !(window.Shopify && window.Shopify.designMode)) tocDetails.open = !klein.matches; }
      tocAnpassen();
      if (klein && klein.addEventListener) klein.addEventListener('change', tocAnpassen);

      // Klebende Leiste am Handy unter den klebenden Kopf des Themes setzen
      var kopf = document.querySelector('.section-header');
      var tocLeiste = wurzel.querySelector('.pillar__toc');
      function kopfHoehe() {
        if (!kopf || !tocLeiste) return;
        var klebt = kopf.classList.contains('shopify-section-header-sticky') && !kopf.classList.contains('shopify-section-header-hidden');
        tocLeiste.style.setProperty('--pillar-kopf', (klebt ? kopf.offsetHeight : 0) + 'px');
      }
      window.addEventListener('scroll', kopfHoehe, { passive: true });
      kopfHoehe();

      // Inhaltsverzeichnis: aktiven Eintrag markieren
      var links = {};
      wurzel.querySelectorAll('[data-pillar-toc]').forEach(function (a) {
        links[a.dataset.pillarToc] = a;
        a.addEventListener('click', function () {
          melde('pillar_toc_click', { pillar: seite, ziel: a.dataset.pillarToc });
          if (tocDetails && klein && klein.matches) tocDetails.open = false;
        });
      });
      var ziele = Object.keys(links).map(function (id) { return document.getElementById(id); }).filter(Boolean);
      if ('IntersectionObserver' in window && ziele.length) {
        var beobachter = new IntersectionObserver(function (eintraege) {
          eintraege.forEach(function (e) {
            if (!e.isIntersecting) return;
            Object.keys(links).forEach(function (k) { links[k].removeAttribute('aria-current'); });
            var a = links[e.target.id];
            if (a) a.setAttribute('aria-current', 'true');
          });
        }, { rootMargin: '-15% 0px -70% 0px', threshold: 0 });
        ziele.forEach(function (z) { beobachter.observe(z); });
      }

      // Filter-Chips: Zeilen nur ein- und ausblenden, nie entfernen
      wurzel.querySelectorAll('[data-pillar-filter]').forEach(function (gruppe) {
        var tabelle = wurzel.querySelector('[data-pillar-table="' + gruppe.dataset.pillarFilter + '"]');
        if (!tabelle) return;
        gruppe.querySelectorAll('[data-pillar-chip]').forEach(function (chip) {
          chip.addEventListener('click', function () {
            var wert = chip.dataset.pillarChip;
            gruppe.querySelectorAll('[data-pillar-chip]').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
            tabelle.querySelectorAll('tbody tr').forEach(function (zeile) {
              var tags = (zeile.dataset.pillarTags || '').split(/\s+/);
              zeile.hidden = !!wert && tags.indexOf(wert) === -1;
            });
            melde('pillar_filter', { pillar: seite, filter: wert || 'alle' });
          });
        });
      });

      // Akkordeon geoeffnet
      wurzel.querySelectorAll('[data-pillar-details]').forEach(function (d) {
        d.addEventListener('toggle', function () { if (d.open) melde('pillar_details_open', { pillar: seite, titel: d.dataset.pillarDetails }); });
      });

      // Rauhnachts-Kalender: heutigen Tag markieren; das Raster und alle Naechte stehen im HTML, nichts wird versteckt
      wurzel.querySelectorAll('[data-pillar-cal]').forEach(function (kal) {
        var heute = new Date(), m = heute.getMonth() + 1, d = heute.getDate();
        var zelle = kal.querySelector('[data-cal-datum="' + m + '-' + d + '"]');
        if (zelle && (m === 12 || m === 1)) { zelle.classList.add('is-heute'); zelle.setAttribute('title', (zelle.getAttribute('title') ? zelle.getAttribute('title') + ', ' : '') + 'heute'); }
        kal.querySelectorAll('.pillar-cal__tag--nacht').forEach(function (a) {
          a.addEventListener('click', function () { melde('pillar_calendar', { pillar: seite, nacht: a.getAttribute('href').split('-').pop() }); });
        });
      });

      // Akkordeon: beim Oeffnen den Eintrag oben unter den klebenden Kopf holen, damit er nicht in der Mitte haengt
      wurzel.querySelectorAll('[data-pillar-details]').forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          window.requestAnimationFrame(function () {
            var kopfH = (kopf && kopf.classList.contains('shopify-section-header-sticky') && !kopf.classList.contains('shopify-section-header-hidden')) ? kopf.offsetHeight : 0;
            var oben = d.getBoundingClientRect().top + window.scrollY - kopfH - 16;
            if (Math.abs(window.scrollY - oben) > 40) window.scrollTo({ top: oben, behavior: ruhig ? 'auto' : 'smooth' });
          });
        });
      });

      // Produkt- und Kartenklicks
      wurzel.querySelectorAll('[data-pillar-product]').forEach(function (a) {
        a.addEventListener('click', function () { melde('pillar_product_click', { pillar: seite, produkt: a.dataset.pillarProduct }); });
      });

      // Sanftes Einblenden der Bausteine beim Scrollen (nicht bei reduzierter Bewegung, nicht im Editor)
      var editor = window.Shopify && window.Shopify.designMode;
      if (!ruhig && !editor && 'IntersectionObserver' in window) {
        wurzel.classList.add('pillar--animiert');
        var einblender = new IntersectionObserver(function (eintraege) {
          eintraege.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('ist-sichtbar'); einblender.unobserve(e.target); } });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
        wurzel.querySelectorAll('.pillar-block').forEach(function (b) { einblender.observe(b); });
      }

      // Scrolltiefe 25/50/75/100
      var marken = [25, 50, 75, 100], gemeldet = {};
      function tiefe() {
        var h = document.documentElement;
        var anteil = Math.round(((window.scrollY + window.innerHeight) / h.scrollHeight) * 100);
        marken.forEach(function (m) {
          if (anteil >= m && !gemeldet[m]) { gemeldet[m] = true; melde('pillar_scroll', { pillar: seite, tiefe: m }); }
        });
      }
      window.addEventListener('scroll', tiefe, { passive: true });
      tiefe();
    }

    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
